import { render, staticRenderFns } from "./VideoRecord.vue?vue&type=template&id=79898346"
import script from "./VideoRecord.vue?vue&type=script&lang=ts"
export * from "./VideoRecord.vue?vue&type=script&lang=ts"
import style0 from "./VideoRecord.vue?vue&type=style&index=0&id=79898346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports